// ── Coordinate space + palette + render helpers ──────────────────────────────
// The shared render concerns the presentation parts need: the fixed coordinate
// space the diagram is drawn in, the helpers that map it to the label overlay,
// and the ink palette. The element placement itself (where each branch/label
// sits) is assembled into the PLACEMENT object in PlanATimelineDiagram.tsx.

// The diagram is drawn in this fixed space and scaled to fit via the SVG viewBox;
// labels are positioned in the same percentage space so they track the lines at
// any width.
export const VB_W = 1000
export const VB_H = 370

// ── Palette ──
// A warm near-black ink, lighter than pure black so the lines feel drawn rather
// than printed; the spine is a touch heavier than the secondary rules.
export const INK = 'rgb(38,38,36)'
export const INK_SOFT = 'rgba(38,38,36,0.55)' // fork branches / perspective tracks
// Page bg — node dots are hollow rings. Tracks the live page backdrop
// (--playbook-epilogue-bg, set by Playbook) so the rings stay "filled with the
// page" as it dims through the epilogue; falls back to cream everywhere the var
// isn't defined (standalone perspective pages, previews).
export const NODE_FILL = 'var(--playbook-epilogue-bg, #fffff8)'
export const SPINE_W = 2.5
export const BRANCH_W = 1.75

// Page background — labels that sit *on* a line paint this behind their text so
// the line reads through the gap rather than colliding with the glyphs. Reads
// the same live-backdrop var as NODE_FILL so on-line labels match the page as
// it transitions; cream fallback keeps non-epilogue render sites unchanged.
export const PAGE_BG = 'var(--playbook-epilogue-bg, #fffff8)'

export const pctX = (x: number) => `${(x / VB_W) * 100}%`
export const pctY = (y: number) => `${(y / VB_H) * 100}%`
